// ** MUI Imports
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Pagination from "@mui/material/Pagination";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";

import React, { useEffect, useState, useRef } from "react";

//API CONFIG
import { API_BASE_URL } from "../../../config/api";

// Mock API function – replace this with your actual API call
const fetchUsers = async (page, limit, search) => {
  const params = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    search: search || ""
  });

  const res = await fetch(`${API_BASE_URL}/api/users?${params.toString()}`);
  const data = await res.json();
  return data;
};

const Customers = () => {
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const debounceTimeout = useRef(null);

  // Fetch users from API
  const getUsers = async () => {
    setLoading(true);
    try {
      const data = await fetchUsers(page, limit, search);
      setUsers(data.users);
      setTotalUsers(data.total);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getUsers();
  }, [page, limit, search]);

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      setPage(1);
    }, 500);
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* Search Bar */}
      <Box sx={{ mb: 2, width: "100%", maxWidth: 600 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search users by name or email..."
          value={search}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Table */}
      <Card>
        <CardHeader title="All Customers" sx={{ pt: 2, alignItems: "center" }} />
        <TableContainer>
          <Table sx={{ minWidth: 350 }} aria-label="users table">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Register Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                    <CircularProgress />
                    <Typography sx={{ mt: 2 }}>Loading users...</Typography>
                  </TableCell>
                </TableRow>
              ) : users.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                    No users found.
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user, index) => (
                  <TableRow key={user._id} hover>
                    <TableCell>
                      <Avatar alt={user.firstName} src="" />
                    </TableCell>
                    <TableCell>{user.firstName} {user.lastName}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.mobile || "N/A"}</TableCell>
                    <TableCell>{user?.createdAt.split("T")[0] || "N/A"}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {/* Pagination */}
      <Card sx={{ mt: 2, py: 2, display: "flex", justifyContent: "center" }}>
        <Pagination
          count={Math.ceil(totalUsers / limit)}
          page={page}
          onChange={handlePaginationChange}
          size="large"
          color="primary"
        />
      </Card>
    </Box>
  );
};

export default Customers;
